import { loadScript } from "./scriptLoader";

export interface MfeModule {
  mount(el: HTMLElement, props: Record<string, unknown>): () => void;
}

export async function loadMfe(url: string, globalKey: string): Promise<MfeModule> {
  await loadScript(url);
  const mod = (window as Record<string, unknown>)[globalKey] as MfeModule | undefined;
  if (!mod?.mount) {
    throw new Error(`MFE "${globalKey}" not found on window after loading ${url}`);
  }
  return mod;
}
